(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.VegetativeCoverController = (function(superClass) {
    extend(VegetativeCoverController, superClass);

    function VegetativeCoverController(scope, transitions, modal, http, service) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.vegetativeCoverChanged = bind(this.vegetativeCoverChanged, this);
      this.setVegetativeCovers = bind(this.setVegetativeCovers, this);
      VegetativeCoverController.__super__.constructor.apply(this, arguments);
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          var ref, ref1;
          if (_this.service.fpcResult.data.manual_vegetative_cover != null) {
            return;
          }
          return _this.http.get("/backend/grower/fieldprint/default-vegetative-covers/" + _this.service.crop + "/" + _this.service.field + "/" + ((ref = _this.service.fpcResult.data.management_system_filters) != null ? ref.fallTillage : void 0) + "/" + ((ref1 = _this.service.fpcResult.data.management_system_filters) != null ? ref1.coverCrop : void 0)).then(function(response) {
            return _this.service.fpcResult.data.vegetative_covers = response.data;
          });
        };
      })(this));
    }

    VegetativeCoverController.prototype.setVegetativeCovers = function(value) {
      return _.fill(this.service.fpcResult.data.vegetative_covers, value);
    };

    VegetativeCoverController.prototype.vegetativeCoverChanged = function() {
      return this.service.fpcResult.data.manual_vegetative_cover = true;
    };

    return VegetativeCoverController;

  })(Controller);

}).call(this);
